import  gql  from 'graphql-tag'

export const catalogSalePercent = gql`query {
        catalogSalePercent {
            edges {
                node {
                    id
                    percent
                }
            }
        }
    }`;
